module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/chicken-portuguese.47c97112.jpg";